<div
  class="header-search"
  [class.header-search_hidden]="!isVisibleAccounts"
>
  <button
    mat-mini-fab
    color="primary"
    (click)="toggleAccount()"
  >
    <i
      class="arrow-icon"
      [class.left]="isVisibleAccounts"
    ></i>
  </button>
  @if (isVisibleAccounts) {
    <mat-form-field
      appearance="outline"
      class="header-search-input header-search-input-accounts"
      [class.header-search-input_hidden]="!isVisibleAccounts"
    >
      <mat-label>Поиск</mat-label>
      <input
        matInput
        type="text"
        [(ngModel)]="searchAccount"
        (ngModelChange)="loadAccounts()"
      >
    </mat-form-field>
  }
</div>
@if (searchAccounts) {
  <div
    class="accounts"
    [class.accounts_hidden]="!isVisibleAccounts"
  >
    @for (account of searchAccounts; track account.accountId) {
      <div
        class="accounts-item"
        [class]="{
          'active': isChatActive(account),
          'account_visible': isVisibleAccounts
        }"
      >
        <button
          class="account"
          (click)="handleSelectAccount(account)"
        >
          <div class="account-icon">
            <img
              class="account-icon-img"
              [src]="getImage(account.accountId)"
              alt=""
            >
          </div>
          @if (isVisibleAccounts) {
            <span
              class="account-name"
              [class.account_visible]="isVisibleAccounts"
            >
              {{ account.accountName }}
            </span>
          }
        </button>
        @if (isVisibleAccounts) {
          <button
            mat-mini-fab
            class="account-update-photo"
            (click)="handleUpdatePhoto(account)"
          >
            <mat-icon>update</mat-icon>
          </button>
        }
      </div>
    }
  </div>
}
